import React, { Component } from 'react';
import Big3Common from "../../js/Big3Common";

/**
* 개발담당:양유빈
* 화면기능:콤보값 공통 컴포넌트, 콤보를 할당 하기 위해 DataSet을 가져온 후 optionList에 할당.
* -------- props --------
* id="apprstate"        : 필수, select id명   
* textName="dtl_name"   : text  할당 json 필드명, 기본값은 text
* valueName="dtl_code"  : value 할당 json 필드명, 기본값은 value
* emptyText="상태선택"   : 콤보 기본 타이틀 값 
* setValue="03"         : DB에서 조회된 선택값 설정 또는 기본값 설정
* ComboChange           : 콤보 이벤트를 부모에 전달 하기 위한 설정
* ex)
    <ComboBox optionList={this.state.baseInfo}
        id="apprstate"
        textName="dtl_name"
        valueName="dtl_code"
        emptyText="상태선택"
        setValue="03"
        ComboChange={this.handleComboChange}
    />
*/
export class ComboBox extends Component {
    static displayName = ComboBox.name;

    constructor(props) {
        super(props);
        this.state = { setValue: '' };
        this.refComboBox = React.createRef();
        this.handleChange = this.handleChange.bind(this);
    }
    //부모 컴포넌트에 선택된 값 전달
    handleChange(event) {
        this.setState({ setValue: event.target.value });
        this.props.ComboChange(event);
    }
    //초기화
    componentDidMount() {
    }
    emptyTextOption(emptyText) {
        return (
            <option key={Big3Common.getGuid()} value=" ">{emptyText}</option>
        )
    }
    //콤보 선택 후 다시 초기화 함수, refComboBox를 이용
    ComboInitSet() {
        this.setState({ setValue: "" });
    }
    
    render() {
        
        let optionList = this.props.optionList === undefined ? null : this.props.optionList;
        let textName = this.props.textName === undefined ? "text" : this.props.textName;
        let valueName = this.props.valueName === undefined ? "value" : this.props.valueName;
        let Id = this.props.id === undefined ? "" : this.props.id;
        let emptyText = this.props.emptyText === undefined ? "" : this.props.emptyText;
        let setValue = this.props.setValue === undefined ? "" : this.props.setValue;
        if (optionList === null) {
            //아직 할당되지 않았으면 기본값으로 대체
            optionList = [{ [textName]: "콤보값없음", [valueName]: Big3Common.getGuid() }]
        }
        return (
            <select id={Id}
                value={this.state.setValue === "" ? setValue : this.state.setValue}
                onChange={this.handleChange}
                className={this.props.className === undefined ? "form-select form-select-sm" : this.props.className}
                aria-label=".form-select-sm"
                ref={this.refComboBox}
            >
                {this.emptyTextOption(emptyText)}
                {
                    optionList.map(list =>
                        <option key={list[valueName]} value={list[valueName]}>{list[textName]}</option>
                    )
                }
            </select>
        );
    }

}

